<template>
  <div>
    <div class="cweek" :loading="loading">
      <div class="cweek-calendar">
        <div>
          <div class="my-2 box-xs-10">
            <v-flex class="cweek-toolbar" ai-center jc-between box-xs-10>
              <div class="cweek-toolbar__item cweek-toolbar__right row-1 md:hide">
                <div class="btn-opacity" @click="type = 'day'" :class="{'active': type == 'day'}">
                  <button>День</button>
                </div>
                <div class="btn-opacity" @click="type = 'week'" :class="{'active': type == 'week'}">
                  <button>Неделя</button>
                </div>
                <!-- <div class="btn-opacity" @click="type = 'month'" :class="{'active': type == 'month'}">
                  <button>Месяц</button>
                </div> -->
              </div>
              <div class="cweek-toolbar__item cweek-toolbar__left row-1">
                <div class="btn-opacity" @click="setToday"><button>Сегодня</button></div>
                <div class="btn-opacity" @click="prev">
                  <button v-if="!maxsm">Назад</button>
                  <button v-else class="px-1"><v-icon size="25">mdi-arrow-left</v-icon></button>
                </div>
                <div class="btn-opacity" @click="next">
                  <button v-if="!maxsm">Вперед</button>
                  <button v-else class="px-1"><v-icon size="25">mdi-arrow-right</v-icon></button>
                </div>
              </div>
              <v-toolbar-title class="mx-6 text-x3" v-if="$refs.calendar">
                {{ $refs.calendar.title }}
              </v-toolbar-title>
            </v-flex>
          </div>
        </div>
        <div class="cweek-calendar__content" v-if="calendar_loaded">
          <v-calendar
            ref="calendar"
            v-model="focus"
            :events="mylessons"
            :type="!maxsm ? type : 'day'"
            :weekdays="weekdays"
            :category-hide-dynamic="true"
            :interval-format="intervalFormat"
            :interval-style="intervalStyle"
            :interval-height="'100'"
            :interval-minutes="'60'"
            :interval-count="'12'"
            first-time="08:00"
            locale="ru-Ru"
            
            :short-intervals="false"
            event-overlap-mode="column"
            :event-overlap-threshold="40"
            :start="currentDay"
            @click:event="showEvent"
            @click:more="viewDay"
            @click:date="viewDay"
            @change="calendarChange"

          >
            <template v-slot:event="{ event }">
              <div class="calendar-lesson" 
                :class="'cweek-type-'+type" 
                :style="`--color-card: ${event.color}`"
                @click="openObject(event)">
                <div class="calendar-lesson__wrapper" :title="event.name">
                  <div class="calendar-lesson__name">{{ event.name }}</div>
                  <span class="calendar-lesson__time">
                    {{ event.start | dateHours}}
                  </span>
                  <!-- <div class="text-x2 fw-6" v-if="type != 'month'">{{ event.classes }}</div> -->
                </div>
              </div>
            </template>
            <template v-slot:day-label-header="{ day, date }">
              <span 
                class="btn-day-label-header" 
                :class="{
                  'today': new Date(date).toLocaleDateString() == new Date().toLocaleDateString(),
                  'current': new Date(date).toLocaleDateString() == new Date(currentDay).toLocaleDateString()
                }"
                @click="viewDay({date})">
                {{ day }}
              </span>
            </template>

          </v-calendar>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dataCalendar from "./calendar.js"
export default {
  watchQuery: true,
  computed: {},
  data(){
    return {
      focus: "",
      type: "week",
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      weekdays: [1, 2, 3, 4, 5, 6, 0],
      loading: true,
      loading_skeleton: false,
      mylessons: [],
      currentDay: new Date(),
      currentList: [],
      todaylist: [],
      calendar_loaded: false,
    }
  },
  watch: {
    '$route.query.date'(date){
      if(!date)
        return
      console.log(date, 'watch date')
      this.timetableParseItems(this.timetables, date)
      this.currentDay = date 
      this.focus = date
    }
  },
	async created() {
    let data
    let date = this.$route.query["date"];
    console.log(data, 'gettimetable')
    
    if(date){
      data = await this.getTimetable({ date: date });
      this.currentDay = date
    }else{
      data = await this.getTimetable();
      date = new Date().toISOString().split('T')[0]
    }
		if (data && data.data) {
      console.log(date, 'create')
      this.timetables = data.data
      this.timetableParseItems(this.timetables, new Date(date))
      console.log(this.timetables, 'this.timetables')
			this.loading = false;
      setTimeout(() => {
        this.calendar_loaded = true;  
      }, 1);
		}
	},
  computed: {
    maxsm: {
      get() {
        return (
          this.$vuetify.breakpoint.name === "xs" ||
          this.$vuetify.breakpoint.name === "sm"
        );
      },
    },
  },
  methods: {
    openObject(item) {
      if (this.holidays[item.date]) {
        return false;
      }

      const element = "item_timetable";

      let query = Object.assign({}, this.$route.query);

      if (query[element] == item.id) {
        return false;
      }

      if (query[element]) {
        delete query[element];
      }

      query[element] = item.id;

      setTimeout(() => {
        this.$router.replace({ query: query });
      }, 20);
    },
    async getTimetable(date) {
      // let date = date || this.date
      // const resp = await this.$http.get(`business/teacher/timetables`, {params: date})
      const resp = await this.$http.get(`business/teacher/timetables`, {params: date})
      console.log(resp, 'resp')
      if (resp && resp.data) {
        let data = resp.data;
        this.holidays = data.holidays;
        return data
      }
    },
    timetableParseItems(timetables_datas, date){
      if (!date)
      date = new Date();
      date = new Date(date).toISOString().split('T')[0];
      console.log(timetables_datas, "timetables_datas", 'date', date)
      this.mylessons = []
      timetables_datas.forEach(item=>{
        this.mylessons.push({
          id: item.id,
          all: item,
          start: `${item.date}T${item.schedule_from_at}`,
          // end: `${item.date}T${item.schedule.till_at}`,
          name: item.discipline_title,
          color: item.discipline_color ? item.discipline_color : '#aaaaaa',
          // icon: item.discipline.icon,
        })
      })
      if( date ){
        console.log(date, 'timeParcse')
        this.currentList = this.mylessons
          .filter(e => 
            new Date(date).toLocaleDateString() == new Date(e.start).toLocaleDateString()
          )
        this.currentDay = new Date(date).toISOString().split('T')[0]
      }
      return this.mylessons;
    },
    intervalStyle(a, getOptions) {},
    intervalFormat(locale, getOptions) { return locale.time; },
    async calendarChange(params){
      console.log(params, 'params')
      let type_day = (this.type === 'day')
      let query_date = params.start.date
      this.loading = true
      this.loading_skeleton = type_day
      const data = this.getTimetable({date: query_date});
      if (data && data.data) {
        this.timetables = data.data;
        // if(!type_day)
        //   query_date = null
        query_date = this.focus
        this.timetableParseItems(this.timetables, query_date)
        
        this.loading = false   
        this.loading_skeleton = false   
      } 
      
    },
    viewDay({ date, ...props }) {
      this.focus = date;
      this.timetableParseItems(this.timetables, this.focus)
    },
    setToday() {
      this.focus = new Date();
      this.timetableParseItems(this.timetables, this.focus)
    },
    async prev() {
      this.$refs.calendar.prev()
    },
    async next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };
      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }
      nativeEvent.stopPropagation();
    },
  },
};
</script>

<style lang="scss" >
.calendar-scroll {
  max-width: 100%;
  overflow-x: scroll;
}
.vc-container {
  text-align: center;
  border: none;
  border-radius: 0;
  width: 100%;
  & .vc-header {
    padding: 10px 0;
  }
  & .vc-weeks {
    padding: 0;
  }
  & .vc-weekday {
    font-size: 15px;
    font-weight: bold;
    color: #68b3c8;
    background-color: var(--weekday-bg);
    border-bottom: var(--weekday-border);
    border-top: var(--weekday-border);
    padding: 10px 0;
    text-transform: capitalize;
  } 
  & .vc-day {
    border: 1px solid #ebebeb;
    text-align: center;
    min-height: 10vmax;
    min-width: 130px;
    font-size: 15px;
    font-weight: bold;
    background: #222;
    padding: 10px 5px 3px 10px;
    text-align: left;
    height: var(--day-height);
    width: var(--day-width);
    color: #111;
    background-color: white;
    &.weekday-1,
    &.weekday-7 {
      background-color: #eff8ff;
    }

    &:not(.on-bottom) {
      border-bottom: var(--day-border);
      &.weekday-1 {
        border-bottom: var(--day-border-highlight);
      }
    }
    &:not(.on-right) {
      border-right: var(--day-border);
    }

    & .vc-day-badge {
      cursor: pointer;
      font-size: 12px;
      color: #313131;
      border-radius: 5px;
      padding: 2px 5px;
      margin-top: 5px;
      line-height: 14px;
      font-weight: 500;
    }
  }
  & .vc-day-dots {
    margin-bottom: 5px;
    color: #111;
  }
}
</style>